var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "c-search-nav" }, [
    _c(
      "ul",
      {
        staticClass: "c-search-nav__container",
        attrs: { "aria-label": "Search Results Tabs" }
      },
      _vm._l(_vm.sites, function(site, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass: "c-search-nav__item",
            class: _vm.activeIndex === index ? "is-active" : null,
            attrs: {
              "aria-current": _vm.activeIndex === index ? "page" : undefined
            }
          },
          [
            _c(
              "button",
              {
                staticClass: "c-search-nav__button",
                on: {
                  click: function($event) {
                    return _vm.getPageContent(index)
                  }
                }
              },
              [
                _vm._v("\n          " + _vm._s(site.siteLabel) + " "),
                _c("span", [_vm._v("(" + _vm._s(site.totalResults) + ")")])
              ]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("p", { staticClass: "c-search-nav__description" }, [
      _vm._v(_vm._s(_vm.searchDescription))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73f33696", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f33696","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/developers/results/SearchNav.vue
// module id = 533
// module chunks = 0